import { TemplateRuleRow } from "./components/RulesModal/RulesModal.types";
import { makeCygnusApiCall } from "../../../api/api";


/**
 * Fetches template rule details.
 * Supports:
 *  - All rules
 *  - Rule by TemplateRuleId
 *  - Single rule condition by TemplateRuleDetailId
 */
export const fetchTemplateFieldRules = async (
  params?: {
    TemplateRuleId?: number;
  }
): Promise<any[]> => {
  const query = new URLSearchParams();

  if (params?.TemplateRuleId) {
    query.append("TemplateRuleId", String(params.TemplateRuleId));
  }

  const response = await makeCygnusApiCall({
    type: "GET",
    url: `/engagement-letter/template_rules/?${query.toString()}`,
    show_message: false,
    customized_success_message: "Fetched rules.",
    customized_failure_message: "Failed to fetch rules.",
    customized_error_message: "Error occurred while fetching rules.",
    isblob: false,
    forMDM: true,
  });

  return response?.data ?? [];
};


/**
 * Saves firm-level rule configurations.
 */
export const saveTemplateFieldConfigDetails = async (
  rulesData: TemplateRuleRow[],
  isDelete?: boolean
): Promise<any> => {

  const payload = {
    FieldRulesConfigs: rulesData,
  };

  const message = isDelete === true ? "Rule deleted successfully." : "Rule saved successfully."
  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/engagement-letter/template_rule_details/",
    payload,
    show_message: true,
    customized_success_message: message,
    customized_failure_message: "Failed to save rule.",
    customized_error_message: "Error occurred while saving rule.",
    isblob: false,
    forMDM: true,
    default_message: true
  });

  return response;
};
